

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/modules/_a-function.js
// module id = ../node_modules/core-js/modules/_a-function.js
// module chunks = 0